import { useLayoutEffect } from 'react';

export const usePageNoScroll = (visible?: boolean) => {
  useLayoutEffect(() => {
    const randomGenerator = Math.floor(Math.random() * 1000);
    if (visible) {
      const scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add(`no-scroll-${randomGenerator}-${scrollY}`);
    }

    return () => {
      const bodyClasses = [...document.body.classList.values()];
      const noScrollClasses = bodyClasses.filter(className =>
        className.includes('no-scroll')
      );
      if (noScrollClasses.length === 0) return;
      const scrollClass =
        noScrollClasses.find(className =>
          className.includes(`no-scroll-${randomGenerator}`)
        ) || '';
      const scrollY = scrollClass.split('-')[3] || '0';
      document.body.classList.remove(`no-scroll-${randomGenerator}-${scrollY}`);
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY));
    };
  }, [visible]);
};
